module.exports = __webpack_public_path__ + "static/JuanHerrerasub-df3159ce6465fcf03d82bab2a8fac271.mp4";